<div
  class="container-md p-md-0"
  [tds-data-loader]="{
    key: 'devices-list',
    global: true
  }"
>
  <div *ngIf="is_admin && (device_list || bp_device_list)" class="row">
    <div class="col">
      <ts-admin-override-banner
        [admin_override]="shopping_cart && shopping_cart.device_include_admin_options"
        (emit_admin_override)="getAdminOverride($event)"
      />
    </div>
  </div>

  <div class="row">
    <div class="col col-3 d-none d-lg-block">
      <ts-filters-index [categories]="categories" [filters]="filters" />
    </div>

    <div class="col col-12 col-lg-9">
      <div class="row justify-content-between">
        <div class="{{ category_filter_sort_classes }}">
          <h4 class="mb-0 d-flex">
            <span class="d-none d-lg-inline mb-0 display-4">
              {{ category_name ? category_name : ('category' | translate) }}
            </span>
            <div
              ngbDropdown
              class="d-inline-block d-lg-none pt-0 mobile-list-sort"
              placement="bottom-left"
            >
              <h4 ngbDropdownToggle id="SwitchCategoryBtn" class="mb-0 cursor-pointer display-4">
                {{ category_name ? category_name : ('category' | translate) }}
              </h4>
              <div ngbDropdownMenu aria-labelledby="SwitchCategoryBtn">
                <!-- items as buttons -->
                <ts-asset-category-filter [categories]="categories" [is_mobile]="true" />
              </div>
            </div>
            <span class="ms-2 text-secondary ms-2 result-count-label">
              ({{ device_list_count }}
              {{
                device_list_count === 1 ? ('item_found' | translate) : ('items_found' | translate)
              }})
            </span>
          </h4>

          <span class="d-flex align-items-center mt-3 mt-md-0">
            <small class="fw-normal">{{ 'sort_by' | translate }}:</small>
            <div ngbDropdown class="d-inline-block mobile-list-sort" placement="bottom-right">
              <button
                ngbDropdownToggle
                id="DeviceSortBtn"
                class="btn btn-sm ms-2 fw-normal focus-visible outlined-btn"
                type="button"
              >
                {{ selected_sort_dropdown_value }}
              </button>
              <div ngbDropdownMenu aria-labelledby="DeviceSortBtn">
                <!-- items as buttons -->
                <button
                  ngbDropdownItem
                  *ngFor="let sort_label of sort_options"
                  class="mobile-list-sort__item"
                  (click)="sortDeviceList(sort_label)"
                >
                  <small>{{ sort_label }}</small>
                </button>
              </div>
            </div>

            <span class="d-block d-lg-none ms-2 mobile-list-filter">
              <button
                class="btn btn-sm fw-normal outlined-btn"
                type="button"
                (click)="openMobileFilters(filterModal)"
              >
                <span class="material-icons-outlined filter-icon">filter_alt</span>
                <span class="fw-normal">{{ 'filter' | translate }}</span>
                <span class="badge text-bg-primary ms-1">{{ filters_count }}</span>
              </button>
            </span>
          </span>
        </div>
      </div>

      <div *ngIf="filter_tokens?.length" class="pt-3">
        <ts-filter-tokens [filter_tokens]="filter_tokens" />
      </div>
      <span *ngIf="!show_no_results; else noDeviceData">
        <div
          *ngIf="!is_bp_response; else bpDevices"
          class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 py-4 g-4"
        >
          <div *ngFor="let device_data of device_list" class="col" role="listbox">
            <div
              as-button
              class="card h-100 elevate overflow-hidden"
              [attr.aria-label]="device_data.manufacturer + ' ' + device_data.model"
              (click)="selectAsset(device_data)"
            >
              <div class="card-body device-card px-0 pt-0">
                <div
                  *ngIf="device_data.in_cart"
                  class="position-absolute top-0 start-100 text-end currently-in-cart"
                >
                  <span ngbTooltip="{{ 'selected_item' | translate }}" class="material-icons">
                    check_circle
                  </span>
                </div>
                <div class="bg-white d-flex flex-column justify-content-center align-items-center">
                  <!-- Device Image -->
                  <img
                    class="device-card__img"
                    src="{{ loadInitialImage(device_data.devices) }}"
                    alt="{{ device_data.manufacturer }} {{ device_data.model }}"
                    loading="lazy"
                    (error)="getPlaceholder(device_data.devices[0].product_category, $event)"
                  />

                  <!-- Admin override badge -->
                  <ts-admin-override-badge
                    *ngIf="device_data.admin"
                    class="position-absolute end-0"
                  />

                  <!-- Color List -->
                  <ul class="mt-3 p-0 d-flex justify-content-center" data-bs-theme="light">
                    <li
                      *ngFor="
                        let device_details of getSortedColorList(device_data.devices);
                        let i = index
                      "
                      [ngClass]="{
                        'multi-color': device_details.color === 'Multicolor',
                        'm-1 rounded-circle device-card__asset-colors--active': i < 4,
                        'ms-1 extra': i === 4,
                        'd-none': i >= 5
                      }"
                      [ngStyle]="{
                        'background-color':
                          device_details.color !== 'Multicolor' && i < 4
                            ? (device_details.color | lowercase)
                            : ''
                      }"
                    >
                      <span *ngIf="i === 4">+{{ unique_color_list_count - 4 }}</span>
                    </li>
                  </ul>
                </div>

                <div class="device-card__content pt-3 border-top">
                  <!-- Carrier Logo -->
                  <div class="mb-2">
                    <img
                      *ngIf="!is_bp_response"
                      class="img-fluid pb-1 carrier-logo"
                      src="{{ device_data.carrier.image_url }}"
                      [alt]="device_data.carrier.name"
                    />

                    <!-- Device Name -->
                    <div class="device-card__content--title line-clamp-2">
                      <span>
                        {{ device_data.manufacturer + ' ' + device_data.model }}
                      </span>
                    </div>
                  </div>

                  <!-- Device Amount -->
                  <div class="text-limit">
                    <small class="fw-normal">{{ 'as_low_as' | translate }}</small>
                    <div class="d-flex align-items-end">
                      <h5 class="pe-1 mb-0">{{ device_data.onetime_minimum_price }}</h5>
                      <small class="text-secondary text-truncate">
                        {{ 'one_time_payment' | translate }}
                      </small>
                    </div>
                    <div *ngIf="device_data.monthly_minimum_price">
                      <small class="text-secondary"> {{ 'plus' | translate }}&nbsp; </small>
                      <h6 class="d-inline-block mb-0">
                        {{ device_data.monthly_minimum_price }}/mo.
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #bpDevices>
          <ts-bp-device-list
            [bp_device_list]="bp_device_list!"
            [sort_by]="current_sort"
            [in_cart_device]="in_cart_device"
            (select_asset_emit)="selectAsset($event)"
          ></ts-bp-device-list>
        </ng-template>
      </span>
    </div>
  </div>
</div>

<ng-template #noDeviceData>
  <div class="alert alert-warning mt-3" role="alert">
    {{ 'no_available_devices' | translate }}
  </div>
</ng-template>

<ng-template #filterModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'filters' | translate }}</h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body pt-0">
    <div class="row mb-3 border-bottom">
      <div class="col">
        <span *ngIf="filter_tokens?.length" class="d-inline-block mb-3">
          <ts-filter-tokens [filter_tokens]="filter_tokens" [is_mobile]="true" />
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <ts-filters-index [categories]="categories" [filters]="filters" [is_mobile]="true" />
      </div>
    </div>
  </div>

  <div class="modal-footer border-top-0 pt-0">
    <button
      class="btn btn-primary mobile-apply-filters"
      type="button"
      (click)="modal.dismiss('Cross click')"
    >
      {{ 'apply_filters' | translate }}
    </button>
  </div>
</ng-template>
